module.exports = __webpack_public_path__ + "static/media/box1-slider.a0678ef2.jpeg";